import { UPDATE_TEMPLATE, UPDATE_TEMPLATE_SUCCESS, UPDATE_TEMPLATE_ERROR, UPDATE_TEMPLATE_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const UpdateTemplate = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TEMPLATE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case UPDATE_TEMPLATE_SUCCESS:
      state = {
        ...state,
        data: action?.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case UPDATE_TEMPLATE_ERROR:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: false,
        error: true,
        message: null,
      };
      break;

    case UPDATE_TEMPLATE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdateTemplate;
